export default "__VITE_ASSET__CjBtCGjO__"